import React from 'react'
import {Link} from 'react-router-dom';

const Suggestions = (props) => {
    const options = props.results.map(r => (
    <Link to={'/formedit/'+r.code} className="no-decoration" key={r.id_original_forms}><span
        className="nav-link">{r.code}</span></Link>
    ))
    return <ul>{options}</ul>
}

export default Suggestions


// WEBPACK FOOTER //
// ./src/components/UI/Suggestions.js